export default "__VITE_ASSET__hman1ahu__"